/**
 * Datas no fuso do consultório (o do navegador de quem atende).
 *
 * `new Date().toISOString().slice(0, 10)` converte para UTC antes de cortar: em
 * São Paulo (UTC−3), das 21:00 em diante o "hoje" virava o dia seguinte, e o
 * painel do dia passava a buscar a agenda de amanhã.
 */
export function dataLocalISO(base = new Date()) {
    const p = (n) => String(n).padStart(2, '0');
    return `${base.getFullYear()}-${p(base.getMonth() + 1)}-${p(base.getDate())}`;
}

/** Duração usada quando a sessão não informa a própria (parâmetro padrão do sistema). */
export const DURACAO_PADRAO_MINUTOS = 50;

/**
 * Fim previsto do atendimento. Serve para distinguir sessão EM ANDAMENTO de
 * sessão atrasada: começar não é atrasar.
 */
export function fimPrevistoSessao(sessao, duracaoPadrao = DURACAO_PADRAO_MINUTOS) {
    if (!sessao?.dataHora) return null;
    const inicio = new Date(sessao.dataHora);
    const minutos = Number(sessao.duracao) > 0 ? Number(sessao.duracao) : duracaoPadrao;
    return new Date(inicio.getTime() + minutos * 60000);
}

/** Sessão em curso: já começou e ainda está dentro da duração prevista. */
export function emAndamento(sessao, agora = new Date()) {
    if (!sessao?.dataHora) return false;
    const fim = fimPrevistoSessao(sessao);
    return new Date(sessao.dataHora) <= agora && !!fim && fim > agora;
}
